export const SIGNUP_PENDING = "SIGNUP_PENDING";

export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";

export const SIGNUP_ERROR = "SIGNUP_ERROR";

export const CHANGE_STATUS = "CHANGE_STATUS";
